window.addEventListener("load", function () {
  const builder = document.querySelector(".custom-builder-v2");
  if (!builder) return;

  const sectionId = builder.dataset.sectionId;
  const canvasId = `builder-canvas-${sectionId}`;
  const productJsonId = `ProductJson-${sectionId}`;

  const canvas = new fabric.Canvas(canvasId);

  const productDataEl = document.getElementById(productJsonId);
  if (!productDataEl) {
    console.warn("Missing product data");
    return;
  }

  const productData = JSON.parse(productDataEl.textContent);
  const productImageUrl = productData.featured_image;

  if (productImageUrl) {
    fabric.Image.fromURL(productImageUrl, function (img) {
      canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
        scaleX: canvas.width / img.width,
        scaleY: canvas.height / img.height
      });
    }, { crossOrigin: "anonymous" });
  }

  const input = builder.querySelector('input[id^="artwork-uploader"]');
  if (!input) {
    console.warn("Upload input not found");
    return;
  }

  const widget = uploadcare.Widget(input);

  widget.onUploadComplete(function (fileInfo) {
    fabric.Image.fromURL(fileInfo.cdnUrl, function (img) {
      const maxWidth = canvas.width * 0.5;
      const maxHeight = canvas.height * 0.5;

      const scaleX = maxWidth / img.width;
      const scaleY = maxHeight / img.height;
      const scale = Math.min(scaleX, scaleY);

      img.set({
        left: canvas.width / 2,
        top: canvas.height / 2,
        originX: "center",
        originY: "center",
        scaleX: scale,
        scaleY: scale,
        selectable: true
      });

      canvas.add(img);
      canvas.setActiveObject(img);
      canvas.renderAll();
    }, { crossOrigin: "anonymous" });
  });
});
